import { getPref, setPref, hydratePrefs } from '../utils/persistentPrefs';
import { DEFAULT_LANGUAGE, isLanguage } from './languages';

const KEY = 'valkenhall-rules-language';
const listeners = new Set();
const valid = (code) => (isLanguage(code) ? code : DEFAULT_LANGUAGE);
// An in-memory language for automated runs: the GUI suite finds its buttons
// by English names and must not rewrite the saved preference on the way.
let override = null;
export function getRulesLanguage() { return override ?? valid(getPref(KEY, DEFAULT_LANGUAGE)); }
export function setRulesLanguage(language) {
  const next = valid(language);
  setPref(KEY, next);
  for (const listener of listeners) listener(next);
}
export function overrideLanguage(language) {
  override = language == null ? null : valid(language);
  for (const listener of listeners) listener(getRulesLanguage());
}
export function subscribeRulesLanguage(listener) {
  listeners.add(listener);
  // Desktop hydration may replace the pre-boot localStorage mirror.
  hydratePrefs().then(() => { if (listeners.has(listener)) listener(getRulesLanguage()); });
  return () => listeners.delete(listener);
}
